import type { ReactNode } from 'react';

export interface HubSlide {
    id: string;
    /** `isActive` is the slide in view, so media can pause off-screen. */
    render: (isActive: boolean) => ReactNode;
}

export interface HubSectionData {
    slides: HubSlide[];
    isLoading: boolean;
    isError: boolean;
}

// Carries its own `to` rather than borrowing the header link's, so a section can send the two
// somewhere different.
export interface HubEndCard {
    to: string;
    heading: string;
    actionLabel: string;
    groundClassName: string;
    zigzagClassName: string;
    zigzagOpacityClassName: string;
}

export interface HubSection {
    id: string;
    title: string;
    blurb: string;
    viewAll: { to: string; label: string } | null;
    endCard: HubEndCard | null;
    /** Tailwind basis class, so it sets how many slides are visible at once. */
    itemBasisClassName: string;
    /** Omit for a section sitting directly on the sheet with its cards as the only surfaces. */
    surfaceClassName?: string;
    /** Always called. A section hides by returning no slides, never by its hook going uncalled. */
    useData: () => HubSectionData;
}

export const defineHubSection = (section: HubSection): HubSection => section;
